import React from "react";
import { Box, Alert } from "@mui/material";

interface ErrorAlertProps {
  message: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <Alert severity="error">{message || "Failed to load data"}</Alert>
    </Box>
  );
};

export default ErrorAlert;
